import classNames from 'classnames';

const RefactoredPanelTitleWrapper = props => {
  const { children, ...rest } = props;
  return <div className={classNames('r-panel__title-wrapper')}>{children}</div>;
};

export default RefactoredPanelTitleWrapper;
